<div id="namPopup"
     class="namPopup">
  <a style="cursor: pointer;"
     id="namPopup-closer"
     class="namPopup-closer"
     (click)="closeNamPopup()"></a>
  
  <div id="namPopup-content">
    <app-related-item *ngFor="let item of namService.namPopupContent;"
                      [relatedItem]="item"
                      [selectedRelatedItemBackground]="selectedObjectBackground$ | async"
                      (selectRelatedObjectToHighlightEvent)="handleSelectRelatedObjectToHighlight($event)"
                      (selectRelatedObjectForEditGeometryEvent)="handleSelectRelatedObjectEditGeometry($event)"
                      (deselectRelatedObjectEvent)="handleDeselectRelatedObjectGeometry($event)"
                      (selectRelatedObjectInfoEvent)="handleSelectRelatedObjectInfo($event)">
    </app-related-item>

  </div>

  <div *ngIf="namService.namPopupContent.length == 0">
    <span>No features to select</span>
  </div>

</div>